<template>
  <div class="admin-forms__wrapper custom-scroll-bar-2">
    <vue-element-loading :active="isLoading" is-full-screen />
    <div class="admin-forms__toolbar">
      <button class="btn-upload cursor-pointer" @click="goCreate">
        <md-icon>add</md-icon>
        Tạo biểu mẫu
      </button>
    </div>

    <div class="admin-forms__table-wrap">
      <table class="ml-member-tbl admin-forms__table">
        <thead>
          <tr>
            <th class="text-400-semibold ml-table-cell">Tiêu đề</th>
            <th class="text-400-semibold ml-table-cell w_min_120">Trạng thái</th>
            <th class="text-400-semibold ml-table-cell w_min_160">Bắt đầu</th>
            <th class="text-400-semibold ml-table-cell w_min_160">Hết hạn</th>
            <th class="text-400-semibold ml-table-cell w_min_100">Phản hồi</th>
            <th class="text-400-semibold ml-table-cell w_min_200">Thao tác</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!forms.length && !isLoading">
            <td colspan="6" class="text-center admin-forms__empty">Chưa có biểu mẫu nào.</td>
          </tr>
          <tr v-for="item in forms" :key="item.id">
            <td class="text-400-medium ml-table-cell">
              <div class="text-400-semibold">{{ item.title }}</div>
              <div class="text-200-default neutral_3">{{ item.slug }}</div>
            </td>
            <td class="ml-table-cell">
              <span class="admin-forms__badge" :class="'status-' + displayStatus(item)">
                {{ statusLabel(displayStatus(item)) }}
              </span>
            </td>
            <td class="text-400-medium ml-table-cell">{{ formatDate(item.starts_at) }}</td>
            <td class="text-400-medium ml-table-cell">{{ formatDate(item.expires_at) }}</td>
            <td class="text-400-medium ml-table-cell">{{ item.response_count || 0 }}</td>
            <td class="ml-table-cell admin-forms__actions">
              <button class="btn-action cursor-pointer" @click="goEdit(item.id)">Sửa</button>
              <button class="btn-action cursor-pointer" @click="goResponses(item.id)">Kết quả</button>
              <button
                v-if="item.status !== 'active'"
                class="btn-action cursor-pointer"
                @click="activate(item)"
              >Active</button>
              <button
                v-else
                class="btn-action cursor-pointer"
                @click="pause(item)"
              >Pause</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination-template
      v-if="pagination.lastPage > 1"
      class="admin-forms__pagination"
      :params="pagination"
      @change-params="changePage"
    />
  </div>
</template>

<script>
import AdminFormService from "../../../../store/services/AdminFormService";
import PaginationTemplate from "../../../Components/PaginationTemplate";
import { FORM_STATUS_LABELS, formatFormDate } from "../../../../helper/formSchema";

export default {
  name: "AdminForms",
  components: { PaginationTemplate },
  data() {
    return {
      forms: [],
      isLoading: false,
      pagination: { page: 1, perPage: 20, lastPage: 1, total: 0 },
    };
  },
  created() {
    this.fetchForms();
  },
  methods: {
    formatDate: formatFormDate,
    statusLabel(key) {
      return FORM_STATUS_LABELS[key] || key;
    },
    displayStatus(item) {
      return item.effective_status || item.status;
    },
    goCreate() {
      this.$router.push("/admin-settings/forms/create");
    },
    goEdit(id) {
      this.$router.push(`/admin-settings/forms/${id}/edit`);
    },
    goResponses(id) {
      this.$router.push(`/admin-settings/forms/${id}/responses`);
    },
    async fetchForms() {
      this.isLoading = true;
      try {
        const res = await AdminFormService.list({
          page: this.pagination.page,
          per_page: this.pagination.perPage,
        });
        if (!res || res.status === false) {
          this.forms = [];
          return;
        }
        const payload = res.data || {};
        this.forms = payload.items || [];
        const paging = payload.pagination || {};
        this.pagination.lastPage = paging.last_page || 1;
        this.pagination.total = paging.total || this.forms.length;
      } finally {
        this.isLoading = false;
      }
    },
    changePage(params) {
      this.pagination.page = params.page;
      this.fetchForms();
    },
    async activate(item) {
      const res = await AdminFormService.activate(item.id);
      if (res && res.status !== false) {
        this.$notify({ type: "success", text: "Đã kích hoạt biểu mẫu" });
        this.fetchForms();
      }
    },
    async pause(item) {
      const res = await AdminFormService.pause(item.id);
      if (res && res.status !== false) {
        this.$notify({ type: "success", text: "Đã tạm dừng biểu mẫu" });
        this.fetchForms();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.admin-forms__wrapper {
  padding: 16px;
}
.admin-forms__toolbar {
  margin-bottom: 16px;
}
.admin-forms__table-wrap {
  overflow: auto;
}
.admin-forms__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.btn-action {
  border: 1px solid #d8dae5;
  background: #fff;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 13px;
}
.btn-upload {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: #2563eb;
  color: #fff;
  border-radius: 8px;
  padding: 8px 14px;
}
.admin-forms__badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  &.status-active { background: #dcfce7; color: #166534; }
  &.status-scheduled { background: #fef9c3; color: #854d0e; }
  &.status-expired, &.status-paused, &.status-draft { background: #f3f4f6; color: #4b5563; }
}
.admin-forms__empty {
  padding: 24px;
  color: #6b7280;
}
</style>
